import { useSearchParameter } from "hooks";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { useTranslation } from "react-i18next";
import { Pagination, SearchInput } from "ui";

import { useMobileMoneyBalance } from "../../apis";
import {
  BalanceLabel,
  RefundDetailsModal,
  RefundsTable
} from "../../components";
import { useRefundsList } from "../../hooks";

import styles from "./Refunds.module.scss";

const Refunds = () => {
  const { t } = useTranslation();

  const {
    refunds,
    totalItems,
    searchValue,
    sorting,
    refetchRefunds,
    setSearchValue,
    setSorting,
    page,
    setPage,
    isLoading
  } = useRefundsList();

  const { balance } = useMobileMoneyBalance();

  const [openedRefundId, setOpenedRefundId] = useSearchParameter("refundId");

  return (
    <ContentLayout
      title={t("Refunds")}
      action={<BalanceLabel label="Wave balance" balance={balance} />}
    >
      <BoxShadowLayout className={styles.pageContent}>
        <SearchInput
          value={searchValue}
          onChange={setSearchValue}
          placeholder={t("Search...")}
        />

        <div className={styles.pageContent_tableContainer}>
          <RefundsTable
            refunds={refunds ?? []}
            isLoading={isLoading}
            sorting={sorting}
            setSorting={setSorting}
            refetchRefunds={refetchRefunds}
          />
        </div>

        <Pagination
          currentPage={page}
          onChange={setPage}
          totalItems={totalItems}
        />
      </BoxShadowLayout>

      <RefundDetailsModal
        isOpen={!!openedRefundId}
        onClose={() => setOpenedRefundId("")}
        refetchRefundsList={refetchRefunds}
      />
    </ContentLayout>
  );
};

export default Refunds;
